var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-base',{attrs:{"route-name":_vm.routeName,"icon":"house-fill"}},[_vm._v(" サイト設定 ")])}
var staticRenderFns = []

export { render, staticRenderFns }